export const environment = {
  production: false,

  //Redirect Websites
  redirectionOptions: {
      enableLoginPageRedirection: false,
      enableLandingPageRedirection: false,
      buyerLandingPageUrl: "https://teccom-portal-demo.azurewebsites.net/orders/basket",
      supplierLandingPageUrl: "https://teccom.demo.tecalliance.cloud/newapp/home/dashboard",
      legacyWelcomePage: 'https://teccom.demo.tecalliance.cloud',
      chineselegacyWelcomePage: 'https://teccom.qa.tecalliance.cn',
      chineseBuyerLandingPageUrl: "https://teccom.qa.tecalliance.cn/newapp/requestorder/basket",
      chineseSupplierLandingPageUrl: "https://teccom.qa.tecalliance.cn/newapp/home/dashboard",
  },

  // Api
  userServiceUrl: 'https://teccom-backend-userservice-qa.azurewebsites.net',
  notificationServiceUrl: 'https://teccom-backend-notificationservice-qa.azurewebsites.net',
  translationServiceUrl: 'https://teccom-backend-translationservice-qa.azurewebsites.net',
  organizationServiceUrl: 'https://teccom-backend-organizationservice-qa.azurewebsites.net',

  // Token
  allowedDomains: ['teccom-backend-organizationservice-qa.azurewebsites.net', 'teccom-backend-notificationservice-qa.azurewebsites.net', 'teccom-backend-userservice-qa.azurewebsites.net'],

  // Excluded domains for internal token
  excludedDomains: ['teccom-backend-userservice-qa.azurewebsites.net', 'teccom-backend-notificationservice-qa.azurewebsites.net'],

  // Okta
  oktaOptions: {
    clientId: '0oa1rn356wpb9hpSg0x7',
    issuerUri: 'https://login.qa.tecalliance.cloud/oauth2/default',
    redirectUri: `${window.location.origin}/callback`,
    postLogoutRedirectUri: `${window.location.origin}/public/welcome`
  },

  // Remotes
  microfrontends: {
    dashboard: {
      remoteUri: 'https://teccom-portal-dashboard-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'dashboard',
      exposedModule: ['DashboardModule'],
    },
    orders: {
      remoteUri: 'https://teccom-portal-orders-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'orders',
      exposedModule: ['OrdersModule'],
    },
    returns: {
      remoteUri: 'https://teccom-portal-returns-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'returns',
      exposedModule: ['ReturnsModule', 'ReturnsPublicModule'],
    },
    invoices: {
      remoteUri: 'https://teccom-portal-invoices-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'invoices',
      exposedModule: ['InvoicesModule'],
    },
    reports: {
      remoteUri: 'https://teccom-portal-reports-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'reports',
      exposedModule: ['ReportsModule'],
    },
    monitoring: {
      remoteUri: 'https://teccom-portal-monitoring-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'monitoring',
      exposedModule: ['MonitoringModule'],
    },
    administration: {
      remoteUri: 'https://teccom-portal-administration-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'administration',
      exposedModule: ['AdministrationModule'],
    },
    network: {
      remoteUri: 'https://teccom-portal-network-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'network',
      exposedModule: ['NetworkModule'],
    },
    connect: {
      remoteUri: 'https://teccom-portal-connect-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'connect',
      exposedModule: ['ConnectModule'],
    },
    internal: {
      remoteUri: 'https://teccom-portal-internal-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'internal',
      exposedModule: ['InternalModule'],
    },
    articleData: {
      remoteUri: 'https://teccom-portal-articledata-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'articledata',
      exposedModule: ['ArticleDataModule']
    },
    maintenance: {
      remoteUri: 'https://teccom-portal-maintenance-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'maintenance',
      exposedModule: ['MaintenanceModule']
    },
    openOrders: {
      remoteUri: 'https://teccom-portal-openorders-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'openorders',
      exposedModule: ['OpenOrdersRemoteModule'],
    },
    registration: {
      remoteUri: 'https://teccom-portal-registration-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'registration',
      exposedModule: ['RegistrationRemoteModule']
    },
    vctool: {
      remoteUri: 'https://teccom-portal-vctool-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'vctool',
      exposedModule: ['VCToolModule']
    },
    orderHistory: {
      remoteUri: 'https://teccom-portal-orderhistory-demo.azurewebsites.net/',
      remoteFile: 'remoteEntry.js',
      remoteName: 'orderhistory',
      exposedModule: ['OrderHistoryRemoteModule']
    }
  },

  // Emails
  supportEmail: 'support@tecalliance.net',

  // Uri
  tecComWikiUri: 'https://help-teccom.tecalliance.net/en/home',
  statusPageUri: 'https://status.tecalliance.net/',
  tecallianceWebSite: 'https://www.tecalliance.net/',
  supportPageUri: 'https://ordersupportweb-qa-frontend.azurewebsites.net/',

  // TODO Remove this when migration is done
  legacyDomainSuffix: '.qa.tecalliance.cloud',
  chineseLegacyDomainSuffix: '.qa.tecalliance.cn',
  legacyUserProfileUri: 'https://teccom.qa.tecalliance.cloud/newapp/user/profile',
  legacySubscriptionUri: 'https://teccom.qa.tecalliance.cloud/newapp/user/subscription',
  legacyOrganizationUri: 'https://teccom.qa.tecalliance.cloud/newapp/administration/organizations',
  legacyWebinarUri: 'https://teccom.qa.tecalliance.cloud/newapp/info/webinars',
  releaseNotesUri: 'https://help-teccom.tecalliance.net/en/user/release-notes',
  legacyLegalNotice: 'https://teccom.qa.tecalliance.cloud/newapp/imprint-info',

  // Application Insights
  appInsights: {
    instrumentationKey: '<PLACEHOLDER_PROD_KEY>',
    enableDebug: false
  }
};
